import FormDisableableMixin from 'mixins/FormDisableableMixin'
import { importComponents } from '~/helpers'

export default {
    mixins: [FormDisableableMixin],

    components: {
        ...importComponents(require.context('components/form-elements')),
        ...importComponents(require.context('components/form-inputs')),
        ...importComponents(require.context('components/form-fields')),
    },
}
